import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.36 23.515a.606.606 0 1 1 0 1.212H6.91a4.242 4.242 0 0 1-4.243-4.242V15.03c0-1.977.073-3.798.22-5.463a4.242 4.242 0 0 1 3.926-3.858c3.527-.25 6.583-.376 9.167-.376 2.588 0 5.657.126 9.206.377a4.242 4.242 0 0 1 3.926 3.858c.148 1.665.221 3.485.221 5.462v5.455c0 2.343-1.9 4.242-4.242 4.242h-2.415a.606.606 0 0 1 0-1.212h2.415a3.03 3.03 0 0 0 3.03-3.03V15.03c0-1.942-.072-3.728-.216-5.355A3.03 3.03 0 0 0 25.1 6.919c-3.522-.25-6.563-.374-9.12-.374-2.553 0-5.58.125-9.081.373a3.03 3.03 0 0 0-2.804 2.755 61.016 61.016 0 0 0-.216 5.357v5.455a3.03 3.03 0 0 0 3.03 3.03h2.45Zm7.177-4.511a.606.606 0 0 0-1.073 0l-3.043 5.807a.606.606 0 0 0 .438.88c.942.155 1.977.233 3.104.233 1.143 0 2.203-.08 3.178-.24a.606.606 0 0 0 .438-.88l-3.042-5.8Zm2.8 7.875a1.818 1.818 0 0 0 1.316-2.638l-3.042-5.8a1.818 1.818 0 0 0-3.22 0l-3.044 5.807a1.818 1.818 0 0 0 1.314 2.638c1.01.167 2.11.25 3.302.25 1.207 0 2.332-.085 3.374-.256Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPresentOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PresentOutlined_default = SvgPresentOutlined;

export { PresentOutlined_default as default };
